import * as React from 'react';

interface ViewProps {
    subscription: number
}

export const RestrictedView: React.SFC<ViewProps> = ({subscription}) => {
    return (
        <>
            <div className="article__restricted-view article__restricted-view--deal">
                <div className="article__restricted-view__padlock">
                    <svg width="25px" height="35px" viewBox="0 0 25 35" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g transform="translate(-507.000000, -248.000000)">
                                <g id="ei-lock-copy-2" transform="translate(491.000000, 237.000000)">
                                    <path d="M39,26 L36.6666667,26 L36.6666667,21.3846154 C36.6666667,16.8846154 33.05,13.3076923 28.5,13.3076923 C23.95,13.3076923 20.3333333,16.8846154 20.3333333,21.3846154 L20.3333333,26 L18,26 L18,21.3846154 C18,15.6153846 22.6666667,11 28.5,11 C34.3333333,11 39,15.6153846 39,21.3846154 L39,26 Z" id="Path" fill="#FFFFFF"></path>
                                    <path d="M37.5909091,46 L19.4090909,46 C17.4772727,46 16,44.4833333 16,42.5 L16,28.5 C16,26.5166667 17.4772727,25 19.4090909,25 L37.5909091,25 C39.5227273,25 41,26.5166667 41,28.5 L41,42.5 C41,44.4833333 39.5227273,46 37.5909091,46 Z M19.1666667,28 C18.4666667,28 18,28.4285714 18,29.0714286 L18,41.9285714 C18,42.5714286 18.4666667,43 19.1666667,43 L37.8333333,43 C38.5333333,43 39,42.5714286 39,41.9285714 L39,29.0714286 C39,28.4285714 38.5333333,28 37.8333333,28 L19.1666667,28 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
                                    <circle id="Oval" fill="#FFFFFF" cx="28.5" cy="33.5" r="2.5"></circle>
                                    <polygon id="Path" fill="#FFFFFF" points="29 33 28 33 27 40 30 40"></polygon>
                                    <rect id="Rectangle" fill-opacity="0" fill="#000000" x="0" y="0" width="57" height="57"></rect>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>

                <div className="article__restricted-view__main-title">Premium Content</div>

                <div className="article__restricted-view__main-text">Access to the Deal Tracker is for premium subscribers only

                    <div className="article__restricted-view__links">
                        {
                            subscription == 1 ?
                            <>Please <a href="/upgrade">upgrade</a> your subscription to view this content</> :
                            <>Please <a href="/wp-login.php">Login</a> or <a href="/signup">subscribe</a> to view this content</>
                        }
                    </div>

                </div>
            </div>
        </>
    )
}
